export const STORE_KEY = '@mega/store';